import React from 'react';
import { Col} from 'reactstrap';


const whyGiveassured = () => (
	<Col sm="12" xs="12" md="12" lg="12" style={{ overflow: 'hidden' }} >


			<h2 className="text-heading-giveAssured" >Why GiveAssured </h2>
			<img styles={{ width: '100%'}} src=" https://s3.ap-south-1.amazonaws.com/give-marketplace/static/images/giveassured/GA-why-giveassured-image.jpg" alt="" />
			<p style={{ paddingTop: '15px' }}>One of our founding philosophies was to bridge the trust gap between donors and the nonprofits that are doing exemplary work in places where there is an actual need and changing the lives of people. And since the year 2000, we have actively worked to meet this gap.
			</p>
			<p>One of our core offerings to our donors is trust, we take this very seriously.  Our GiveAssured framework is designed to bring you trust, which is why we verify and validate all the legal requirements that a nonprofits needs to follow.
			</p>
			<p>We are the only online giving platform in the country that has a robust and rigorous due-diligence process that is comprehensive in all parameters.
			</p>
			<p>We do this so that you can give with confidence.
			</p>



	</Col>


);

export default whyGiveassured;
